var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg-icon',_vm._g({class:_vm.classes,attrs:{"name":_vm.nameIcon}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }